import { BaseEditViewStore } from "core/stores";
import { TrackingCaseDocumentFieldValueEditDynamicForm } from "application/tracking-case/forms";
import { TrackingCaseDocumentFieldValueService } from "application/tracking-case/services";
import { action, observable, runInAction } from 'mobx';

class TrackingCaseDocumentFieldValueEditViewStore extends BaseEditViewStore {
	@observable accessor items = null;
	trackingCaseDocumentId = this.rootStore.routerStore.routerState.params.trackingCaseDocumentId;

	constructor(rootStore) {
        const service = new TrackingCaseDocumentFieldValueService(rootStore.application.baasic.apiClient);

        const id = rootStore.routerStore.routerState.params.trackingCaseDocumentId;
        super(rootStore, {
			name: "trackingCaseDocumentFieldValue",
			autoInit: false,
			id: id,
			actions: {
				get: async () => { //async id => {
					return this.items;
				},
				update: async resource => {
					this.items.forEach(item => {
						item.value = resource[item.documentFormField.abrv];
					});

					const response = await service.batchUpdate(this.items);
					return response.data;
				}
			},
			errorActions: {
				onUpdateError: ({ error }) => {
					rootStore.notificationStore.error('TRACKING_CASE_DOCUMENT_FIELD_VALUE.EDIT.ERROR', error);
				}
			},
			FormClass: TrackingCaseDocumentFieldValueEditDynamicForm
		});

        this.service = service;

        this.fetch([this.onInit()]);
    }

	@action.bound
	async onInit() {
		await this.fillFormFields();

		this.fetch([
			this.initialize()
		]);
    }

	@action.bound
	async fillFormFields() {
		const response = await this.service.find({trackingCaseDocumentId: this.trackingCaseDocumentId, rpp: 1000, embed: 'documentFormField,documentFormField.documentFormFieldType,trackingCaseDocument,trackingCaseDocument.documentType,trackingCaseDocument.documentForm'});
		response.data.item = response.data.item.filter(x=>x.documentFormField.top && x.documentFormField.left); // temp: where top and left is set
		this.backgroundImage = response.data.item.some(x=> x.trackingCaseDocument.documentType.abrv === 'pn') ? 'progressNotes.png' :
		response.data.item.some(x=> x.trackingCaseDocument.documentForm.abrv === 'standard-written-order') ? 'standardWrittenOrder.png' :
		'trackingCaseFieldValuesTemplate.png';

		response.data.item.forEach(item => {
			const documentFormField = item.documentFormField;

			let rules = '';
			// if(documentFormField.isRequired) {
			// 	rules += "required";
			// }

			this.form.add({ name: documentFormField.abrv, rules: rules });

			// #region Parsing field types

			switch(item.documentFormField.documentFormFieldType.abrv){
				case "check": item.value = !item.value ? false : item.value.toLowerCase() == "true"; break;
			}

			//#endregion Parsing field types

			item[item.documentFormField.abrv] = item.value;

			this.form.update(item);
		});

		runInAction(() => {
			this.items = response.data.item;
		});

		return true;
	}
}

export default TrackingCaseDocumentFieldValueEditViewStore;
